<template>
  <form-layout
    class="project-form"
    entity-name="project"
    :loading="isLoading"
    @save="saveProject"
  >
    <template #title>
      <h1 class="text-xl font-bold uppercase">{{ titleText }}</h1>
    </template>
    <template #body>
      <template v-if="userType === 'admin'">
        <bdg-text-field
          ref="name"
          name="Project name"
          v-model="formData.name"
          required
        />

        <bdg-dropdown
          ref="type"
          name="Status"
          :options="statusOptions"
          placeholder="Select one"
          v-model="formData.type"
          required
        />

        <bdg-dropdown
          ref="primaryContact"
          name="Primary contact"
          :options="computedContacts"
          :search-text="contactSearchText"
          @search-input="contactSearchText = $event"
          v-model="primaryContactAndPlaceIds"
          :loading="isGettingContacts"
          searchable
          required
        />

        <bdg-multi-select
          name="Additional contacts"
          empty-state-message="No additional contacts added"
          begin-typing-message="Begin typing contact name"
          :list-item-component="freeResponseCellComponent"
          :search-function="freeResponseSearch"
          v-model="formData.additional_contacts"
          :loading="isGettingContacts"
        />

        <bdg-aside title="Project address" />
        <p class="text-sm text-mid-gray">
          * Changes to project address will store as an additional address in
          the contact record.
        </p>
        <bdg-address-fields ref="place" v-model="formPlace" required />

        <bdg-aside title="Other project details" />
        <p class="text-sm text-mid-gray">
          * Changes to primary phone will store as an additional phone in the
          contact record.
        </p>
        <bdg-text-field name="Email address" v-model="formData.email" />

        <bdg-phone-number-field
          ref="primaryPhone"
          name="Primary Phone"
          v-model="formData.primary_phone"
        />

        <bdg-phone-number-field
          :ref="`additionalPhone${i}`"
          name="Additional Phone"
          @remove="removePhoneNumber(i)"
          v-model="formData.additional_phones[i]"
          v-for="(phone, i) in formData.additional_phones"
          :key="`phone_${i}`"
          removable
        />

        <bdg-add-field
          class="mb-3"
          add-text="Add phone number"
          v-model="formData.additional_phones"
          :new-value="newPhoneNumber()"
        />

        <bdg-text-field name="Gate code" v-model="formData.gate_code" />
      </template>

      <bdg-text-area name="Note" v-model="formData.note.text" />
    </template>
  </form-layout>
</template>

<script>
import goBack from "../mixins/goBack";
import BdgTextField from "./fields/BdgTextField";
import BdgDropdown from "./fields/BdgDropdown";
import BdgTextArea from "./fields/BdgTextArea";
import FormLayout from "../views/layouts/FormLayout";
import { ProjectStatuses } from "../constants/enums";
import BdgMultiSelect from "./fields/BdgMultiSelect";
import CustomerCell from "../elements/free-response-select/CustomerCell";
import BdgAddField from "./fields/BdgAddField";
import BdgPhoneNumberField from "./fields/BdgPhoneNumberField";
import BdgAddressFields from "./fields/BdgAddressFields";
import ProjectContractForms from "./ProjectContractForms";
import BdgAside from "../elements/BdgAside";

export default {
  name: "ProjectForm",
  extends: ProjectContractForms,
  components: {
    BdgAside,
    BdgAddressFields,
    BdgPhoneNumberField,
    BdgAddField,
    BdgMultiSelect,
    FormLayout,
    BdgTextArea,
    BdgDropdown,
    BdgTextField
  },
  mixins: [goBack],
  data() {
    return {
      statusOptions: Object.values(ProjectStatuses),
      formData: {
        id: this.id,
        name: this.name,
        type: this.type,
        primary_contact_id: this.primary_contact_id,
        additional_contacts: this.additional_contacts.slice(),
        additional_contact_ids: this.additional_contact_ids.slice(),
        place_id: this.place.id,
        email: this.email,
        primary_phone: this.primary_phone.clone(),
        additional_phones: this.additional_phones.slice(),
        gate_code: this.gate_code,
        note: Object.assign({}, this.note),
        new_primary_contact_name: null
      },
      freeResponseCellComponent: CustomerCell
    };
  },
  computed: {
    titleText() {
      return this.id ? "Edit Project" : "Create New Project";
    },
    isStoringProject() {
      return this.$store.state.Projects.isStoringProject;
    },
    isUpdatingProject() {
      return this.$store.state.Projects.isUpdatingProject;
    },
    isLoading() {
      return this.id ? this.isUpdatingProject : this.isStoringProject;
    }
  }
};
</script>
